import { useEffect } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import {
  HOTTIE_SHEET_STATE,
  hottieLandingPath,
  setHottieReturnTo,
} from '../open';

/**
 * `/hottie` — deep link only. Not a page.
 *
 * Sibling sites still point here. This route stores `return_to` (never
 * auto-navigated) and lands on a real surface with the in-kit HottieSheet
 * asked to open. It must not dump onto a blank screen or hop the Orb hold
 * through this URL as if it were a destination.
 */
export function HottiePage() {
  const [params] = useSearchParams();

  useEffect(() => {
    setHottieReturnTo(params.get('return_to'), params.get('from'));
  }, [params]);

  const dest =
    typeof window === 'undefined'
      ? '/feed'
      : hottieLandingPath(document.referrer || null, window.location.origin);

  return <Navigate to={dest} replace state={HOTTIE_SHEET_STATE} />;
}

export default HottiePage;
